<template>
  <main>

    <b-alert v-model="error" variant="danger" dismissible>
      {{ msg_alert }}
    </b-alert>

    <div class="event-page">

      <!-- ÉVÉNEMENT -->
      <div v-if="event" class="event-header">

        <h1 class="event-name">
          {{ event.name }}
        </h1>

        <div v-if="event.date" class="event-date">
          {{ formatDate(event.date) }}
        </div>

        <div v-if="event.notes" class="event-notes">
          {{ event.notes }}
        </div>

        <div class="event-count">
          {{ users.length }}
          inscrit{{ users.length > 1 ? 's' : '' }}
        </div>

        <div class="event-export">
          <b-button variant="primary" :disabled="!loaded" @click="exportUsers">
            Export
          </b-button>
        </div>

      </div>


      <!-- CLIENTS -->
      <section class="users-section">

        <h2>Clients inscrits</h2>


        <!-- Aucun client -->
        <div
            v-if="users.length === 0"
            class="empty-state"
        >
          Aucun client inscrit à cet événement.
        </div>


        <!-- Liste des clients -->
        <div v-else class="users-list">

          <b-card
              v-for="user in users"
              :key="user.id"
              class="user-card"
          >

            <div class="user-header">

              <span class="user-name">
                {{ user.name }}
              </span>

              <a
                  v-if="user.tel"
                  :href="'sms:' + user.tel"
                  class="user-phone"
              >
                {{ formatPhone(user.tel) }}
              </a>

            </div>


            <div
                v-if="user.notes"
                class="user-notes"
            >
              {{ user.notes }}
            </div>

          </b-card>

        </div>

      </section>

    </div>

  </main>
</template>


<script>

import {get_event} from "../services/ApiServices";
import {utils, writeFileXLSX} from "xlsx";

export default {

  name: 'list-user-evenement-view',
  props: ['event_id'],

  data: () => {
    return {
      error: false,
      msg_alert: '',
      loaded: false,
      event: {},
      users: []
    }
  },

  methods: {

    exportUsers() {
      const sheet = utils.aoa_to_sheet(this.users.map(user => [user.name, user.tel]));
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, sheet, 'Inscrits');
      writeFileXLSX(workbook, `evenement-${this.event_id}-inscrits.xlsx`);
    },

    formatDate(date) {
      if (!date) {
        return '';
      }
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },


    formatPhone(phone) {
      if (!phone) {
        return '';
      }

      const cleaned = phone
          .toString()
          .replace(/\D/g, '');

      const parts = cleaned.match(/.{1,2}/g);
      return parts ? parts.join('.') : cleaned;
    }
  },

  mounted() {
    console.log(this.event_id);
    get_event(this.event_id)
        .then(response => {
          this.event = response.event;
          console.log(this.event);
          this.users = response.users;
          this.loaded = true;
        })
        .catch(() => {
          this.error = true;
          this.msg_alert = "Impossible de charger l'événement.";
        });
  }

}

</script>


<style scoped lang="scss">

/* =========================================
   PAGE
   ========================================= */

.event-page {
  width: 100%;
}

.event-export {
  margin-top: 15px;
}


/* =========================================
   ÉVÉNEMENT
   ========================================= */

.event-header {
  width: 100%;
  max-width: 700px;

  margin: 0 auto 45px;

  text-align: center;
}


/* Titre */

.event-name {
  margin: 0;

  font-size: 32px;
  font-weight: 600;

  color: #173b6c;

  text-transform: capitalize;
}


/* Date = sous-titre */

.event-date {
  margin-top: 7px;

  font-size: 17px;
  font-weight: 400;

  color: #666;
}


/* Notes événement */

.event-notes {
  margin-top: 14px;

  font-size: 15px;

  color: #444;
}


/* Nombre d'inscrits */

.event-count {
  display: inline-block;

  margin-top: 15px;

  padding: 5px 13px;

  background: #f0f2f4;

  border-radius: 20px;

  font-size: 14px;

  color: #333;
}


/* =========================================
   CLIENTS
   ========================================= */

.users-section {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
}


.users-section h2 {
  width: 100%;
  max-width: 400px;

  margin: 0 0 18px;

  font-size: 22px;
  font-weight: 500;

  color: #222;
}


/* =========================================
   LISTE
   ========================================= */

.users-list {
  width: 100%;
  max-width: 400px;
}


/* =========================================
   CARTE CLIENT
   ========================================= */

.user-card {
  width: 100%;
  max-width: 400px;

  margin-bottom: 12px;

  border: 1px solid #dedede;
  border-radius: 7px;

  box-shadow: none;
}


.user-card ::v-deep .card-body {
  padding: 18px 20px;
}


/* =========================================
   NOM + TELEPHONE
   ========================================= */

.user-header {
  display: flex;

  align-items: center;
  justify-content: space-between;

  gap: 15px;
}


.user-name {
  font-size: 16px;
  font-weight: 600;

  color: #181818;
}


.user-phone {
  font-size: 16px;
  font-weight: 600;

  color: #287bc1;

  text-decoration: none;

  white-space: nowrap;
}


.user-phone:hover {
  color: #1d65a2;

  text-decoration: none;
}


/* =========================================
   NOTES CLIENT
   ========================================= */

.user-notes {
  margin-top: 14px;

  padding-top: 11px;

  border-top: 1px solid #e5e5e5;

  font-size: 14px;
  font-weight: 400;

  color: #333;
}


/* =========================================
   AUCUN CLIENT
   ========================================= */

.empty-state {
  width: 100%;
  max-width: 400px;

  padding: 25px;

  background: rgba(255, 255, 255, 0.7);

  border: 1px solid #e1e1e1;
  border-radius: 7px;

  text-align: center;

  color: #555;
}


/* =========================================
   MOBILE
   ========================================= */

@media (max-width: 576px) {

  .event-page {
    padding: 25px 15px 40px;
  }


  .event-header {
    margin-bottom: 35px;
  }


  .event-name {
    font-size: 27px;
  }


  .event-date {
    font-size: 16px;
  }


  .event-notes {
    font-size: 14px;
  }


  .users-section h2 {
    font-size: 20px;
  }


  .user-card ::v-deep .card-body {
    padding: 16px;
  }


  .user-name,
  .user-phone {
    font-size: 15px;
  }

}


/* Très petits téléphones */

@media (max-width: 360px) {

  .user-header {
    flex-direction: column;

    align-items: flex-start;

    gap: 5px;
  }

}

</style>
